<template lang="pug">
.giftpopup
  .giftpopup__overlay
    .giftpopup__card
      .giftpopup__card__content
        p(v-html="$t('giftpopup.lead')")
        DownloadButton
          | {{ $t("giftpopup.download") }}
      .giftpopup__card__close-btn(@click="closePopup")
</template>
<script>
import DownloadButton from "./DownloadButton.vue";
export default {
  name: "GiftPopup",

  components: {
    DownloadButton,
  },

  mounted() {
    window.addEventListener("keydown", this.escHandler);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.escHandler);
  },

  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    escHandler(e) {
      if (e.keyCode === 27) {
        this.closePopup();
      }
    },
  },
};
</script>
